import script from "./CopyIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CopyIcon.vue?vue&type=style&index=0&id=c5bd1758&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/blueshift-vesting-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5bd1758"]])

export default __exports__